module.exports = __webpack_public_path__ + "static/media/with-charger.8488d57b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/airpods/with-charger.jpeg
// module id = 2053
// module chunks = 0